import { render } from "./UserID.vue?vue&type=template&id=14d20430&scoped=true"
import script from "./UserID.vue?vue&type=script&lang=js"
export * from "./UserID.vue?vue&type=script&lang=js"

import "./UserID.vue?vue&type=style&index=0&id=14d20430&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d20430"]])

export default __exports__